module.exports = __webpack_public_path__ + "static/lampLight-9f1708f563ec396dd566a15141859433.png";